export default "__VITE_ASSET___FWPf$Xw__"